import Reveal from "@/components/feature/Reveal";
import SectionHeading from "./SectionHeading";
import { channels } from "@/mocks/channels";

export default function Channels() {
  return (
    <section id="channels" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="投稿通道"
            title="三条投稿通道，总有一条适合你的线索"
            description="不需要注册账号，也不需要真实姓名。选择你觉得最自在的方式，把知道的那部分交给我们，剩下的由编辑核实。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 md:mt-14 md:grid-cols-3 md:gap-6">
          {channels.map((item, index) => (
            <Reveal key={item.id} delay={index * 90} className="h-full">
              <article className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300 md:p-7">
                <div className="flex items-start justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-2xl text-primary-600 md:h-14 md:w-14 md:text-3xl">
                    <i className={item.icon} aria-hidden="true" />
                  </span>
                  <span className="whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                    {item.tag}
                  </span>
                </div>

                <h3 className="mt-6 font-heading text-lg font-bold text-foreground-950 md:text-xl">
                  {item.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {item.desc}
                </p>

                <a
                  href={item.href}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
                >
                  {item.action}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}